import React from "react";
import Header from "../components/header";
import { useStaticQuery, graphql, Link, navigate } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
// import MinimalFooter from "../components/minimalFooter";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectCoverflow, Mousewheel } from "swiper/modules";
import { IconArrowNarrowRight } from "@tabler/icons-react";

import Seo from "../components/seo";
import useLongPress from "../components/longclick";
import { motion } from "framer-motion";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

function translateDate(dateStr) {
  // Convert the string to a Date object
  var dateObj = new Date(dateStr);

  // Get month name
  var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  var monthName = months[dateObj.getMonth()];

  // Get day
  var day = dateObj.getDate();

  // Get year
  var year = dateObj.getFullYear();

  // Formulate the translated date string
  var translatedDate = monthName + " " + day + ", " + year;

  return translatedDate;
}

function orderByDate(array) {
  // Use the sort() method to sort the array based on the date property
  array.sort(function (postA, postB) {
    // Convert the date strings to Date objects
    var dateA = new Date(postA.date);
    var dateB = new Date(postB.date);

    // Compare the dates
    return dateB - dateA;
  });

  return array;
}

export default function Blog({ data }) {
  const { title, content, slug } = data.wpPage;

  const postsByDate = orderByDate(data.allWpPost.nodes);



  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500,
  };

  function addSlide(swiper) {
    let r = swiper.realIndex,
      p = swiper.previousIndex;
    let currentIndex = 1;

    let previousSlideElement = swiper.slides[swiper.previousIndex];
    let currentSlideElement = swiper.slides[swiper.activeIndex];
    // currentSlideElement.childNodes[0].childNodes[2]
    let currentTitle =
      currentSlideElement.childNodes[0].getElementsByTagName("a")[0];
    let previousTitle =
      previousSlideElement.childNodes[0].getElementsByTagName("a")[0];

    previousTitle.style.opacity = "0";
    currentTitle.style.opacity = "100";
  }

  const longPressEvent = useLongPress(
    defaultOptions
  );

  const posts = data.allWpPost.nodes.map((post) => {
    var translatedDate = translateDate(post.date);

    return (
      <SwiperSlide className="flex px-4 lg:px-[0px] xl:max-w-[400px] lg:pt-8">
        <Link
          className="group justify-start flex flex-col  md:gap-8 xl:gap-12 scale-100 hover:scale-[0.9]  lg:hover:scale-[1.10] transition-scale duration-300 ease-in-out bg-cream md:p-4"
          to={`/post/${post.slug}`}
        >
          {post.featuredImage && (
            <GatsbyImage
              image={post.featuredImage.node.gatsbyImage}
              objectPosition={0}
              objectFit="cover"
              className="w-full min-h-[300px] h-[20vh] blog-cover-image  "
            />
          )}
          <div className="flex flex-col justify-start gap-2">
            <div>
              <span className="font-caslon text-2xl md:text-xl ">
                {translatedDate}
              </span>
            </div>
            <h2 className="text-xl md:text-3xl group-hover:text-red transition-text duration-300 ease-in-out">
              {post.title}
            </h2>
            <p
              dangerouslySetInnerHTML={{ __html: post.excerpt }}
              className="text-sm xl:text-md hidden md:block"
            ></p>
          </div>

          <Link
            className="group justify-start flex flex-row items-center lg:hidden transition-all ease-in-out duration-300 opacity-100"
            onTouchEnd={() => {
              navigate(`/post/` + post.slug);
            }}
          >
            <h6
              className={`uppercase w-fit text-sm underline underline-offset-[10px]`}
            >
              Read post
            </h6>
            <motion.div
              animate={{
                transform: [
                  "translateX(0px)",
                  "translateX(20px)",
                  "translateX(0px)",
                ],
              }}
              transition={{
                repeat: Infinity,
                duration: 0.75,
                type: "ease-in-out",
                repeatDelay: 1,
              }}
            >
              <IconArrowNarrowRight
                size={40}
                stroke={0.75}
                className={`transition-all ease-in-out duration-100`}
              />
            </motion.div>
          </Link>
        </Link>
      </SwiperSlide>
    );
  });

  const isLooping = posts.length < 7 ? false : true;

  return (
    <main className="flex sm:justify-center h-[100dvh] overflow-x-hidden xl:overflow-hidden">
      <Header />
      {/* pt-[130px] sm:pt-[130px] md:pt-[130px] xl:pt-[150px] */}
      <section className=" flex flex-col items-center justify-center h-full pt-[92px]">
        <section className="px-4 mb-[30px]">
          {/* RANDOM COMMENT */}
          <h1 className="text-6xl sm:text-6xl uppercase text-center">
            {title}
          </h1>
          <p
            dangerouslySetInnerHTML={{ __html: content }}
            className="text-center"
          ></p>
        </section>

        <div className="w-[100vw] z-0 ">
          <Swiper
            spaceBetween={10}
            loop={false}
            slidesPerView={4}
            direction="horizontal"
            loopedSlides={3}
            mousewheel={{
              enabled: true,
              sensitivity: 1,
              releaseOnEdges: true,
            }}
            centeredSlides={true}
            grabCursor={true}
            pagination={{
              el: ".swiper-pagination",
              clickable: true,
              renderBullet: function (index, className) {
                return `<span class="${className}"></span>`;
              },
            }}
            breakpoints={{
              1500: {
                slidesPerView: 3,
                spaceBetween: 10,
                centeredSlides: true,
              },

              1024: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              840: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              615: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              425: {
                slidesPerView: 1,
                spaceBetween: 10,
                centeredSlides: false,
              },

              100: {
                slidesPerView: 1,
                centeredSlides: false,
              },
            }}
            modules={[EffectCoverflow, Pagination, Mousewheel]}
            id="swiper-category"
            // pl-[0px] lg:pl-[7vw] xl:pl-[10vw]
            // onSlideChange={(swiper) => addSlide(swiper)}
            init={(swiper) => addSlide(swiper)}
            className="blog-swiper"
          >
            {[...posts]}
          </Swiper>
        </div>
      </section>

      {/* <MinimalFooter/> */}
    </main>
  );
}

export function Head({ data }) {
  const {
    wpPage: { seo },
  } = data;

  return (
    <Seo
      title={seo.title}
      description={seo.metaDesc}
      url={data.site.siteMetadata.siteUrl + "/blog"}
      image={"../images/opengraph-royal.webp"}
    ></Seo>
  );
}

export const query = graphql`
  query Blog {
    site {
      siteMetadata {
        siteUrl
      }
    }
    wpPage(title: { eq: "Latest Blogs" }) {
      title
      slug
      content
      seo {
        title
        metaDesc
        canonical
      }
    }

    allWpPost {
      nodes {
        content
        excerpt
        slug
        title
        date
        featuredImage {
          node {
            gatsbyImage(width: 600)
          }
        }
      }
    }
  }
`;
